module.exports = __webpack_public_path__ + "img/frame (48).edcdc375.jpg";